const GET_CONFIG_KEYS = 'dofe-bo/configuration/GET_CONFIG_KEYS'
const GET_CONFIG_KEYS_SUCCESS = 'dofe-bo/configuration/GET_CONFIG_KEYS_SUCCESS'
const GET_CONFIG_KEYS_FAIL = 'dofe-bo/configuration/GET_CONFIG_KEYS_FAIL'
const GET_CONFIG_KEY_VALUE = 'dofe-bo/configuration/GET_CONFIG_KEY_VALUE'
const GET_CONFIG_KEY_VALUE_SUCCESS =
  'dofe-bo/configuration/GET_CONFIG_KEY_VALUE_SUCCESS'
const GET_CONFIG_KEY_VALUE_FAIL =
  'dofe-bo/configuration/GET_CONFIG_KEY_VALUE_FAIL'
const GET_CONFIG_VALUES = 'dofe-bo/configuration/GET_CONFIG_VALUES'
const GET_CONFIG_VALUES_SUCCESS =
  'dofe-bo/configuration/GET_CONFIG_VALUES_SUCCESS'
const GET_CONFIG_VALUES_FAIL = 'dofe-bo/configuration/GET_CONFIG_VALUES_FAIL'

const GET_CONFIG_KEYS_VALUES = 'dofe-bo/configuration/GET_CONFIG_KEYS_VALUES'
const GET_CONFIG_KEYS_VALUES_SUCCESS =
  'dofe-bo/configuration/GET_CONFIG_KEYS_VALUES_SUCCESS'
const GET_CONFIG_KEYS_VALUES_FAIL =
  'dofe-bo/configuration/GET_CONFIG_KEYS_VALUES_FAIL'

const initialState = {
  keys: [],
  values: {},
  allValues: []
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONFIG_KEYS:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        keys: action.result
      }
    case GET_CONFIG_KEYS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_CONFIG_VALUES:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_VALUES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        allValues: action.result
      }
    case GET_CONFIG_VALUES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_CONFIG_KEY_VALUE:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEY_VALUE_SUCCESS:
      // temporary solution - display list on configuration values in UI

      if (!action.result.configurationKey) {
        return {
          ...state,
          loading: false
        }
      }

      return {
        ...state,
        loading: false,
        loaded: true,
        values: Object.assign({}, state.values, {
          [action.result.configurationKey.keyName.value]: {
            ...action.result
          }
        })
      }
    case GET_CONFIG_KEY_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case GET_CONFIG_KEYS_VALUES:
      return {
        ...state,
        loading: true
      }
    case GET_CONFIG_KEYS_VALUES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        values: action.result.reduce((acc, item) => Object.assign(acc, {
          [item.configurationKey.keyName.value]: {
            ...item
          }
        }), { ...state.values })
      }
    case GET_CONFIG_KEYS_VALUES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getConfigurationKeys() {
  return {
    types: [GET_CONFIG_KEYS, GET_CONFIG_KEYS_SUCCESS, GET_CONFIG_KEYS_FAIL],
    promise: client => client.get('api/configuration-keys')
  }
}

export function getConfigurationKeyValue(name, organizationId, removeToken) {
  const routeParams = organizationId ? `?organizationId=${organizationId}` : ''

  const reqParams = removeToken ? { removeToken: true } : undefined

  return {
    types: [
      GET_CONFIG_KEY_VALUE,
      GET_CONFIG_KEY_VALUE_SUCCESS,
      GET_CONFIG_KEY_VALUE_FAIL
    ],
    promise: client =>
      client.get(
        `api/configuration-keys/${name}/value${routeParams}`,
        reqParams
      )
  }
}

export function getConfigurationKeysValues(values, organizationId) {
  return {
    types: [
      GET_CONFIG_KEYS_VALUES,
      GET_CONFIG_KEYS_VALUES_SUCCESS,
      GET_CONFIG_KEYS_VALUES_FAIL
    ],
    promise: client =>
      client.get(
        `api/configuration-values/organization/${organizationId}?keys=${values.join(',')}`
      ),
    organizationId
  }
}

export function getConfigurationAllValues(organizationId) {
  return {
    types: [
      GET_CONFIG_VALUES,
      GET_CONFIG_VALUES_SUCCESS,
      GET_CONFIG_VALUES_FAIL
    ],
    promise: client =>
      client.get(`api/configuration-values/organization/${organizationId}`)
  }
}
